import { config } from 'cfg'

export const POI_ENDPOINTS = {
  POI: () => `${config.apiBaseUrl}/poi`
}
